export default "__VITE_ASSET__C0x9nw1t__"